"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _XDATOVDXcjs = require('./XDATOVDX.cjs');


var _PFM4PJSGcjs = require('./PFM4PJSG.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');



var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/dialog/dialog-heading.tsx
var _react = require('react');
var TagName = "h1";
var useDialogHeading = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useDialogHeading2({ store, ...props }) {
    const setHeadingId = _react.useContext.call(void 0, _PFM4PJSGcjs.DialogHeadingContext);
    const id = _3BSDKDKDcjs.useId.call(void 0, props.id);
    _3BSDKDKDcjs.useSafeLayoutEffect.call(void 0, () => {
      setHeadingId == null ? void 0 : setHeadingId(id);
      return () => setHeadingId == null ? void 0 : setHeadingId(void 0);
    }, [setHeadingId, id]);
    props = {
      ...props,
      id
    };
    props = _XDATOVDXcjs.useHeading.call(void 0, props);
    return props;
  }
);
var DialogHeading = _PTOCUU2Dcjs.forwardRef.call(void 0, function DialogHeading2(props) {
  const htmlProps = useDialogHeading(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useDialogHeading = useDialogHeading; exports.DialogHeading = DialogHeading;
